export default class NotificationsHub {
    constructor(api) {
        this.api = api;
        this.NotificationsHubClass = null;
    }

    async init(instance) {
        if (this.api && this.api.settings && this.api.settings.notificationsHubInstance && this.api.settings.notificationsHubInstance !== instance.instance) {
            return;
        }

        if (!this.NotificationsHubClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                 await this.api.util.loadJS(instance.data.cdn.js);
                // await this.api.util.loadJS(["http://localhost:8081/widget_notificationsHub.js"]);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.notificationsHub &&
                this.api.settings.widgetsUrl.notificationsHub.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.notificationsHub.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                 await this.api.util.loadCSS(instance.data.cdn.css);
                // await this.api.util.loadCSS(['http://localhost:63342/widgets/dist/notificationsHub/css/notificationsHub.css']);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.notificationsHub &&
                this.api.settings.widgetsUrl.notificationsHub.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.notificationsHub.css]);
            }
        }

        if (window.store) {
            window.store.dispatch('addInstanceToContainer', instance.instance)
            this.createInstance(instance)
        }
    }

    createInstance(instance) {
        if (!document.getElementById(`ox-drawer-instance-container-${instance.instance}-inner`)) {
            setTimeout(()=> {
                this.createInstance(instance)
            },100)
        } else {
            this.NotificationsHubClass = new window.Widget_notificationsHub.default(this.api.settings, `#ox-drawer-instance-container-${instance.instance}-inner`, instance.instance, this.api);
        }
    }
}